/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class ReassignLeadSuccess extends React.Component<*> {
  componentDidMount() {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const user: Object = actionDrawerStore.response.project_lead;
    this.props.projectDetailsStore.details.project_lead.id = user.id; // eslint-disable-line camelcase
    // this.props.projectDetailsStore.details.project_lead.name = `${ user.first_name } ${ user.last_name }`;
    this.props.projectDetailsStore.details.project_lead = user; // eslint-disable-line camelcase
  }

  render(): React.Node {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const { t }: TranslatorProps = this.props;
    const project: Object = this.props.response;
    const user: Object = project.project_lead;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.reassigned_lead')}
          >
            <p>
              {t('general:projects.messages.reassigned_to', {
                project: `${project.code} - ${project.name}`,
              })}
            </p>
            <ul>
              <li>{`${user.first_name} ${user.last_name}`}</li>
              <li>
                <b>{t('general:roles.labels.current_role')}</b>:{' '}
                {t(`general:roles.${user.role_id}`)}
              </li>
            </ul>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
